import { environment } from "../../../environments/environment";

export const SECURITY = {
  AUTHORIZATION_BASIC: {
    BEFORE_LOGIN: environment.authorizationApiToken_BEFORE,
    AFTER_LOGIN: environment.authorizationApiToken_AFTER //'Basic TVUzOTY4MjU0Njc1OjI4NWxLdUkzN3BBNVAyOTU3NDUxR3Q0OUJ1Mjh3MjdQaVU/Cg=='
  }
};

export const API_TUNNING_URL = {
  POST_TUNNING: {
    path: '/tunings',
    params: {
      id: {
        key: 'id',
        value: '',
      },
      createdAt: {
        key: 'createdAt',
        value: '',
      },
      ua: {
        key: 'file',
        value: '',
      },
      browserName: {
        key: 'browserName',
        value: '',
      },
      browserVersion: {
        key: 'browserVersion',
        value: '',
      },
      engineName: {
        key: 'engineName',
        value: '',
      },
      engineVersion: {
        key: 'engineVersion',
        value: '',
      },
      osName: {
        key: 'osName',
        value: '',
      },
      osVersion: {
        key: 'osVersion',
        value: '',
      },
      deviceModel: {
        key: 'deviceModel',
        value: '',
      },
      deviceType: {
        key: 'deviceType',
        value: '',
      },
      deviceVendor: {
        key: 'deviceVendor',
        value: '',
      },
      cpuArchitecture: {
        key: 'cpuArchitecture',
        value: '',
      },
      resultNetwork: {
        key: 'resultNetwork',
        value: '',
      },
      resultCamara: {
        key: 'resultCamara',
        value: '',
      },
      resultMicrophone: {
        key: 'resultMicrophone',
        value: '',
      },
      resultBrowser: {
        key: 'resultMicrophone',
        value: '',
      },
      connectionId: {
        key: 'connectionId',
        value: '',
      },
      attendant: {
        key: 'attendant',
        value: '',
      },
    },
    security: {
      authorizationBasic: SECURITY.AUTHORIZATION_BASIC.AFTER_LOGIN,
    },
  },
  PATCH_TUNNING: {
    path: '/tunings/{id}?connection={connectionId}',
    params: {
      id: {
        key: 'id',
        value: '',
      },
      connectionId: {
        key: 'connectionId',
        value: '',
      },
    },
    security: {
      authorizationBasic: SECURITY.AUTHORIZATION_BASIC.AFTER_LOGIN,
    },
  }
};
